(function(){
  var KEY='lz_scratch_seen';
  var overlay=document.querySelector('[data-lz-scratch-overlay]');
  if(!overlay)return;
  var closeBtn=overlay.querySelector('[data-lz-scratch-close]');
  var form=overlay.querySelector('[data-lz-scratch-form]');
  var skipBtn=overlay.querySelector('[data-lz-scratch-skip]');
  var steps={
    scratch:overlay.querySelector('[data-lz-step="scratch"]'),
    claim:overlay.querySelector('[data-lz-step="claim"]'),
    revealed:overlay.querySelector('[data-lz-step="revealed"]')
  };
  var canvas=overlay.querySelector('[data-lz-scratch-canvas]');
  var labelEl=overlay.querySelector('[data-lz-scratch-label]');
  var claimHeadingEl=overlay.querySelector('[data-lz-scratch-heading]');
  var finalHeadingEl=overlay.querySelector('[data-lz-scratch-final-heading]');
  var finalCodeEl=overlay.querySelector('[data-lz-scratch-final-code]');
  var welcomeCodeEl=overlay.querySelector('[data-lz-scratch-welcome-code]');

  var PRIZES=[
    {code:'LIZNA2',label:'2% DTO',heading:'Has ganado un 2% de descuento.',weight:32},
    {code:'LIZNA3',label:'3% DTO',heading:'Has ganado un 3% de descuento.',weight:27},
    {code:'LIZNA5',label:'5% DTO',heading:'Has ganado un 5% de descuento.',weight:20},
    {code:'LIZNA8',label:'8% DTO',heading:'Has ganado un 8% de descuento.',weight:13},
    {code:'LIZNAENVIO',label:'ENVÍO GRATIS',heading:'Has ganado envío gratis.',weight:8}
  ];
  var chosenPrize=null;

  function pickWeightedPrize(){
    var total=0;
    for(var i=0;i<PRIZES.length;i++)total+=PRIZES[i].weight;
    var r=Math.random()*total;
    for(var j=0;j<PRIZES.length;j++){
      r-=PRIZES[j].weight;
      if(r<=0)return PRIZES[j];
    }
    return PRIZES[0];
  }

  var params=new URLSearchParams(window.location.search);
  var forceShow=params.get('rasca')==='1';

  function alreadySeen(){
    if(forceShow)return false;
    try{return localStorage.getItem(KEY)==='1';}catch(e){return false;}
  }
  function markSeen(){
    try{localStorage.setItem(KEY,'1');}catch(e){}
  }
  function open(){
    if(alreadySeen())return;
    overlay.hidden=false;
    document.documentElement.style.overflow='hidden';
    initScratch();
  }
  function close(){
    overlay.hidden=true;
    document.documentElement.style.overflow='';
    markSeen();
  }
  function showStep(name){
    Object.keys(steps).forEach(function(k){steps[k].hidden=(k!==name);});
  }

  closeBtn.addEventListener('click',close);
  overlay.addEventListener('click',function(e){if(e.target===overlay)close();});
  if(skipBtn)skipBtn.addEventListener('click',close);

  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var fullname=form.querySelector('input[name="fullname"]').value.trim();
      var email=form.querySelector('input[name="email"]').value.trim();
      var phone=form.querySelector('input[name="phone"]').value.trim();
      var addWelcome=form.querySelector('input[name="add_welcome"]').checked;
      if(!fullname||!email||!chosenPrize)return;

      var nameParts=fullname.split(' ');
      var body=new URLSearchParams();
      body.append('form_type','customer');
      body.append('utf8','✓');
      body.append('contact[first_name]',nameParts[0]||'');
      body.append('contact[last_name]',nameParts.slice(1).join(' ')||'');
      body.append('contact[email]',email);
      if(phone)body.append('contact[phone]',phone);
      body.append('contact[tags]','newsletter,lz-rasca,'+chosenPrize.code+(addWelcome?',lz-welcome':''));
      fetch('/contact#newsletter',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:body.toString()}).catch(function(){});

      if(finalHeadingEl)finalHeadingEl.textContent=chosenPrize.heading;
      if(finalCodeEl)finalCodeEl.textContent=chosenPrize.code;
      var sub=overlay.querySelector('[data-lz-scratch-final-sub]');
      if(addWelcome){
        if(welcomeCodeEl){welcomeCodeEl.hidden=false;welcomeCodeEl.textContent='+ LIZNA10 (bienvenida)';}
        if(sub)sub.textContent='Aplica los dos códigos en el carrito, se combinan:';
      }else{
        if(welcomeCodeEl)welcomeCodeEl.hidden=true;
        if(sub)sub.textContent='Usa este código en el carrito:';
      }
      showStep('revealed');
    });
  }

  function initScratch(){
    if(!canvas||canvas._lzInit)return;
    canvas._lzInit=true;
    chosenPrize=pickWeightedPrize();
    var ctx=canvas.getContext('2d');
    function paintCover(){
      ctx.clearRect(0,0,canvas.width,canvas.height);
      var grad=ctx.createLinearGradient(0,0,canvas.width,canvas.height);
      grad.addColorStop(0,'#8a8f98');
      grad.addColorStop(1,'#b9bec7');
      ctx.fillStyle=grad;
      ctx.fillRect(0,0,canvas.width,canvas.height);
      ctx.fillStyle='rgba(255,255,255,.5)';
      ctx.font='bold 16px sans-serif';
      ctx.textAlign='center';
      ctx.fillText('RASCA AQUÍ',canvas.width/2,canvas.height/2+6);
    }
    paintCover();
    ctx.globalCompositeOperation='destination-out';
    var scratching=false;
    var revealed=false;

    function pos(e){
      var rect=canvas.getBoundingClientRect();
      var cx=(e.touches?e.touches[0].clientX:e.clientX)-rect.left;
      var cy=(e.touches?e.touches[0].clientY:e.clientY)-rect.top;
      return {x:cx*(canvas.width/rect.width),y:cy*(canvas.height/rect.height)};
    }
    function scratchAt(p){
      ctx.beginPath();
      ctx.arc(p.x,p.y,22,0,Math.PI*2);
      ctx.fill();
    }
    function checkRevealed(){
      if(revealed)return;
      var data=ctx.getImageData(0,0,canvas.width,canvas.height).data;
      var cleared=0,total=data.length/4;
      for(var i=3;i<data.length;i+=4*20){if(data[i]===0)cleared++;}
      if(cleared/(total/20)>0.5){
        revealed=true;
        if(labelEl)labelEl.textContent=chosenPrize.label;
        canvas.style.transition='opacity .4s ease';
        canvas.style.opacity='0';
        setTimeout(function(){
          if(claimHeadingEl)claimHeadingEl.textContent=chosenPrize.heading;
          showStep('claim');
        },500);
      }
    }
    function start(e){scratching=true;scratchAt(pos(e));}
    function move(e){if(!scratching)return;e.preventDefault();scratchAt(pos(e));checkRevealed();}
    function end(){scratching=false;checkRevealed();}

    canvas.addEventListener('mousedown',start);
    canvas.addEventListener('mousemove',move);
    window.addEventListener('mouseup',end);
    canvas.addEventListener('touchstart',start,{passive:true});
    canvas.addEventListener('touchmove',move,{passive:false});
    canvas.addEventListener('touchend',end);
  }

  setTimeout(open,forceShow?300:4000);
})();
